import { NgModule } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzMentionModule } from 'ng-zorro-antd/mention';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzMessageService, NzMessageServiceModule } from 'ng-zorro-antd/message';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzRateModule } from 'ng-zorro-antd/rate';
@NgModule({
	exports: [
		NzIconModule,
		NzButtonModule,
		NzCardModule,
		NzCheckboxModule,
		NzDropDownModule,
		NzFormModule,
		NzInputModule,
		NzIconModule,
		NzNotificationModule,
		NzTabsModule,
		NzLayoutModule,
		NzPageHeaderModule,
		NzBadgeModule,
		NzDividerModule,
		NzBreadCrumbModule,
		NzSpaceModule,
		NzAutocompleteModule,
		NzSelectModule,
		NzTableModule,
		NzModalModule,
		NzRadioModule,
		NzStepsModule,
		NzInputNumberModule,
		NzListModule,
		NzCollapseModule,
		NzMentionModule,
		NzUploadModule,
		NzSwitchModule,
		NzDatePickerModule,
		NzStatisticModule,
		NzMessageServiceModule,
		NzImageModule,
		NzTagModule,
		NzRateModule
	]
})

export class NgZorroAntdModule { }
